import { lowerLanguage } from "src/i18n";

import { CountryData } from "react-phone-input-2";
import { ChangeEvent, FocusEvent } from "react";
import { InputPhoneProps } from "src/types";

import "./input-phone.scss";
import "react-phone-input-2/lib/material.css";

export const useInputPhone = ({
  name,
  setFieldValue,
  setFieldTouched,
}: InputPhoneProps) => {
  const country =
    lowerLanguage === "it" ? "it" : lowerLanguage === "en" ? "gb" : "de";

  const onChangePhone = (
    value: string,
    data: CountryData,
    event: ChangeEvent<HTMLInputElement>,
    formattedValue: string
  ) => {
    if (!setFieldValue) return;

    setFieldValue(name, {
      country: data,
      formattedPhone:
        value === (data as CountryData)?.dialCode ? value : formattedValue,
      value: formattedValue,
    });
  };

  const onBlurPhone = (
    event: FocusEvent<HTMLInputElement, Element>,
    data: CountryData | {}
  ): void => {
    if (!setFieldTouched) return;

    setFieldTouched(`${name}.formattedPhone`, true);
  };

  return { country, onChangePhone, onBlurPhone };
};
